import { r360Api } from '../../services/services'
import { setAbility } from '../../utils/permissions/ability'

export const Actions = {
    GET_ACTIONS_REQUEST: 'GET_ACTIONS_REQUEST',
    GET_ACTIONS_FAILURE: 'GET_ACTIONS_FAILURE',
    GET_ACTIONS_SUCCESS: 'GET_ACTIONS_SUCCESS',
}

export const getActionsRequest = () => {
    return { type: Actions.GET_ACTIONS_REQUEST }
}

export const getActionsError = (error: any) => {
    return { type: Actions.GET_ACTIONS_FAILURE, error }
}

export const getActionsSuccess = (actions: string[]) => {
    return {
        type: Actions.GET_ACTIONS_SUCCESS,
        actions,
    }
}

export const getActions = (user: any) => {
    return (dispatch: any) => {
        dispatch(getActionsRequest())
        r360Api
            .GetActions()
            .then((res: any) => {
                if (res && res.data && res.data.permissions) {
                    const permissions: any[] = res.data.permissions
                    dispatch(getActionsSuccess(permissions))
                    setAbility(permissions, user)
                }
            })
            .catch((error: Error) => {
                dispatch(getActionsError(error))
            })
    }
}
